import { Flex, type FlexProps, Typography } from 'antd';
import { type ReadingStatus, type ReadingType } from 'infrastructure/enums';
import { type IPatientThresholds } from 'infrastructure/interfaces/i-patient-thresholds';
import {
  type TStatuses,
  type Value,
} from 'infrastructure/interfaces/i-rpm-patient-activity';
import React from 'react';
import { getActivityThresholdsValues } from 'utils';

const { Text } = Typography;

interface IThresholdsListProps extends Omit<FlexProps, 'children'> {
  id: string;
  globalStatus: ReadingStatus;
  values: Value;
  statuses: TStatuses;
  readingType: ReadingType;
  thresholds: IPatientThresholds;
}

const ThresholdsList: React.FC<IThresholdsListProps> = ({
  id,
  globalStatus,
  values,
  statuses,
  readingType,
  thresholds,
  ...props
}) => {
  const riskItems = getActivityThresholdsValues(
    globalStatus,
    values,
    statuses,
    thresholds,
    readingType,
  );

  return (
    <Flex vertical justify="center" {...props}>
      {riskItems.map((item, index) => (
        <Text key={`${id}-${index}`}>{item}</Text>
      ))}
    </Flex>
  );
};

export default ThresholdsList;
